/* eslint-disable */
import React, { Component } from "react";
import "./App.css";
import Commentary from "./scenes/Commentary/Commentary";

class App extends Component {

  render() {
    return (
      <div className="App">
        <Commentary />
      </div>
    );
  }
}

export default App;
/* eslint-disable */